export const getReturnPath = (from) => {
  if (!from || typeof from !== 'object' || Array.isArray(from) || typeof from.pathname !== 'string') return '/dashboard';
  const unsafe = /[\\\u0000-\u001f\u007f]/;
  if (!from.pathname.startsWith('/') || from.pathname.startsWith('//') || unsafe.test(from.pathname)) return '/dashboard';
  const search = typeof from.search === 'string' && from.search.startsWith('?') && !unsafe.test(from.search) ? from.search : '';
  const hash = typeof from.hash === 'string' && from.hash.startsWith('#') && !unsafe.test(from.hash) ? from.hash : '';
  return `${from.pathname}${search}${hash}`;
};
